import { getNonDeletedElements } from "@/lib/elements";
import { LinearElementEditor } from "@/lib/elements";
import { isLinearElement, isTextElement } from "@/lib/elements";

import { KEYS, arrayToMap } from "@/lib/common";

import { selectGroupsForSelectedElements } from "@/lib/elements";

import { CaptureUpdateAction } from "@/lib/elements";

import type { DrawinkElement } from "@/lib/elements/types";

import { selectAllIcon } from "../components/icons";

import { register } from "./register";

export const actionSelectAll = register({
  name: "selectAll",
  label: "labels.selectAll",
  icon: selectAllIcon,
  trackEvent: { category: "canvas" },
  viewMode: false,
  perform: (elements, appState, _value, app) => {
    if (appState.selectedLinearElement?.isEditing) {
      return false;
    }

    const selectedElementIds = elements
      .filter(
        (element) =>
          !element.isDeleted && !(isTextElement(element) && element.containerId) && !element.locked,
      )
      .reduce((map: Record<DrawinkElement["id"], true>, element) => {
        map[element.id] = true;
        return map;
      }, {});

    return {
      appState: {
        ...appState,
        ...selectGroupsForSelectedElements(
          {
            editingGroupId: null,
            selectedElementIds,
          },
          getNonDeletedElements(elements),
          appState,
          app,
        ),
        selectedLinearElement:
          // single linear element selected
          Object.keys(selectedElementIds).length === 1 && isLinearElement(elements[0])
            ? new LinearElementEditor(elements[0], arrayToMap(elements))
            : null,
      },
      captureUpdate: CaptureUpdateAction.IMMEDIATELY,
    };
  },
  keyTest: (event) => event[KEYS.CTRL_OR_CMD] && event.key === KEYS.A,
});
